import { createUseStyles } from "react-jss";

export const useChainStyles = createUseStyles({
  polygonZkEvmChain: {
    height: 20,
    width: 20,
  },
});
